import { useEffect, useRef, useState } from 'react';
export var useExtractionMessage = function useExtractionMessage() {
  var _useState = useState('Preparing extraction'),
      label = _useState[0],
      setLabel = _useState[1];

  var interval = useRef();
  useEffect(function () {
    interval.current = setInterval(function () {
      setLabel(['Reading your documents', 'Extracting your data', 'Extracting your policy number', 'Extracting your insurance products', 'Extracting your liability level', 'Extracting your start and expiry date', 'Extracting your premium', 'Extracting your deductible', 'Extracting your excess', 'Just a few more seconds', 'Almost done', 'We are almost done'][Math.floor(Math.random() * 12)]);
    }, 3000);
    return function () {
      return clearInterval(interval.current);
    };
  }, [interval]);
  return {
    label: label
  };
};